// src/shared/services/supabase.ts
//
// Einzige Datenbankverbindung des Intranets. Alle Bereiche nutzen diese eine
// Instanz, auch die Dateien, die über src/lib/supabaseClient.ts einbinden.
// Zwei getrennte Verbindungen würden dieselbe Anmeldung parallel verwalten und
// könnten sich bei der automatischen Verlängerung der Sitzung gegenseitig stören.
// Ausnahme: Die Zustimmungsseite des Chat-Connectors (src/pages/
// ChatZustimmungPage.tsx) führt eine eigene Verbindung mit eigenem
// Speicherplatz, weil sie ein anderes Konto anmeldet.
//
// Verwendet wird der öffentliche Anon Key, nie der Service-Role-Key.
//
// detectSessionInUrl ist aus (03.11.2026): Die Sitzung des Intranets kommt
// immer vom Server (netlify/functions/supabase-auth.js, setSession), nie aus
// der Adresszeile. Eingeschaltet würde die Bibliothek bei einer Fehlermeldung
// in der Adresszeile (etwa nach einem abgebrochenen Rücksprung von DATEV oder
// von Google) die Intranet-Sitzung in diesem Browser löschen.

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false
  },
  db: {
    schema: 'public'
  }
});

// Hinweis im Browserprotokoll, wenn beim Laden bereits eine Sitzung besteht
supabase.auth.getSession().then(({ data: { session } }) => {
  if (session) {
    console.log('Existing session found');
  }
});
